import { TranslationKeyEnvUtils } from "@evennt-tech/api-v2-core";

export const ENV_KEY_PREFIX = TranslationKeyEnvUtils.resolvePrefix(
  import.meta.env.VITE_APP_VERSION
);

export const stripEnvKeyPrefix = <T extends { translationKey: string }>(
  item: T
): T => ({
  ...item,
  translationKey: TranslationKeyEnvUtils.strip(item.translationKey),
});

export const withEnvScopedKeyNames = <T extends { keyName: string }>(
  items: T[]
): T[] =>
  items.map((item) => ({
    ...item,
    keyName: TranslationKeyEnvUtils.build(ENV_KEY_PREFIX, item.keyName),
  }));
